"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BankcardApi = void 0;
var tslib_1 = require("tslib");
/* eslint-disable */
/* 此代码由工具自动生成,不要直接修改,以免下次生成会丢失 */
var di_1 = tslib_1.__importDefault(require("@jsmodules/di"));
var getApi_1 = tslib_1.__importDefault(require("../../getApi"));
var BankcardApi = /** @class */ (function () {
    function BankcardApi() {
        this.http = getApi_1.default('api_v1');
    }
    /**
     * 添加,查询列表
     * @method POST 添加
     * @method GET 查询列表
     *
     */
    BankcardApi.prototype.Bankcard = function () {
        return this.http
            .url("/api/Bankcard")
            .addSecurityHeaders()
            .support('POST', 'GET');
    };
    /**
     * 删除,更新,获取指定Id数据
     * @method DELETE 删除
     * @method PUT 更新
     * @method GET 获取指定Id数据
     *
     * @params id 无说明
     */
    BankcardApi.prototype.BankcardById = function (id) {
        return this.http
            .url("/api/Bankcard/" + id)
            .addSecurityHeaders()
            .support('DELETE', 'PUT', 'GET');
    };
    /**
     * 获取支持的银行列表
     * @method GET 获取支持的银行列表
     *
     */
    BankcardApi.prototype.banks = function () {
        return this.http
            .url("/api/Bankcard/banks")
            .addSecurityHeaders()
            .support('GET');
    };
    BankcardApi.diOptions = di_1.default.options({
        name: "BankcardApi",
        scope: "Singleton"
    });
    return BankcardApi;
}());
exports.BankcardApi = BankcardApi;
exports.default = BankcardApi;
